import React from "react"
import store from "src/store"
import ParameterInput from "./parameter-input"
import { useStepIndex } from "./step-index-context"

export default function ChoosetTimeStamp() {
  var stepIndex = useStepIndex()

  store.useRerenderIfChange(() => [
    store.steps[stepIndex]?.["customTimestamp"],
    store.steps[stepIndex]?.["timestamp"],
  ])

  var customTimestamp = store.steps[stepIndex]["customTimestamp"]
  var timestamp = store.steps[stepIndex]["timestamp"] || 0

  return (
    <div css="background: white;padding-left:10px;padding-top:10px;">
      <div css="display:flex;">
        <div
          css={`
            width: 110px;
            flex-shrink: 0;
          `}
        >
          Timestamp
        </div>
        <div
          css={`
            flex-grow: 1;
          `}
        >
          <span css="font-weight: 700">
            {!customTimestamp && "Default"}
            {customTimestamp && "Custom"}
            &nbsp;
          </span>
          {!store.isStepReadOnly(stepIndex) && (
            <span
              css={`
                color: #799fd4;
                cursor: pointer;
                text-decoration-line: underline;
                justify-self: right;
                font-size: 13px;
                font-weight: 100;
              `}
              onClick={() => {
                store.removeResults(stepIndex)
                store.steps[stepIndex]["customTimestamp"] =
                  !store.steps[stepIndex]["customTimestamp"]
                store.updateStore()
              }}
            >
              Change
            </span>
          )}
        </div>
      </div>
      {customTimestamp && (
        <>
          <div>
            <ParameterInput
              type="uint256"
              disabled={store.isStepReadOnly(stepIndex)}
              label="Block.timestamp"
              labelBackground="white"
              onChange={(e) => {
                try {
                  store.removeResults(stepIndex)
                  store.steps[stepIndex]["timestamp"] = parseInt(e.target.value)
                  store.updateStore()
                } catch (err) {}
              }}
              value={timestamp}
              showMaxButton = {false}
            />
          </div>
        </>
      )}
    </div>
  )
}
